
import { Component, Vue } from 'vue-property-decorator';
import { WPXFormValue } from '@/components/templates/WPXForm';
import CreateScoreTypeForm from '@/services/QA/scoreType/forms/CreateScoreTypeForm';
import ScoreTypeRepositoryInterface, { ScoreTypeInterface } from '@/services/QA/scoreType/interfaces';

@Component({
  inject: [
    'scoreTypeRepository',
  ],
})
export default class CreateScoreType extends Vue {
  private readonly scoreTypeRepository!: ScoreTypeRepositoryInterface;
  private loading: boolean = true;
  private form: WPXFormValue<CreateScoreTypeForm> = new WPXFormValue(CreateScoreTypeForm);

  public created(): void {
    this.loading = false;
  }

  private async createScoreType(): Promise<void> {
    try {
      await this.scoreTypeRepository.createScoreType({
        label: this.form.data.label,
      });

      this.$successDialog.show(`Score Type '${this.form.data.label}' has been created`);
      await this.$router.push({ path: '/qc/score/types' });
    } catch (err) {
      this.$errorDialog.show(err.response.data.message);
    }
  }
}
